import { LinkButtonLink } from 'components/compass-integration'
import { VisitorIdLink } from 'components/VisitorIdLink'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.VisitorId
const label = 'visitorID' // visitFilterLabelMap[key] // conforming the existing analytics label

function VisitorIdCell({ visitorId, workspaceId }: { visitorId: string; workspaceId: string }) {
  return (
    <VisitorIdLink visitorId={visitorId} workspaceId={workspaceId} showCopy={false}>
      {({ canNavigate, linkProps }) =>
        canNavigate ? (
          <LinkButtonLink {...linkProps} variant='ghost' className='font-mono font-normal'>
            {visitorId}
          </LinkButtonLink>
        ) : (
          <span className='font-mono ml-3'>{visitorId}</span>
        )
      }
    </VisitorIdLink>
  )
}

export const visitorIdColumn = ({ workspaceId }: { workspaceId: string }) =>
  columnHelper.display({
    id: 'visitorId',
    header: 'Visitor ID',
    cell: ({ row }) => {
      const visitorId = row.original.identification?.visitor_id

      if (!visitorId) {
        return <Unavailable />
      }

      return (
        <CellAction
          copyValue={visitorId}
          search={(old) => ({ ...old, [key]: visitorId })}
          field={label}
          wrapperClassName='-ml-3 -my-2'
          className='overflow-visible'
        >
          <VisitorIdCell visitorId={visitorId} workspaceId={workspaceId} />
        </CellAction>
      )
    },
  })
